<script>
import Loading from "@/components/c-loading";
// import Swal from "sweetalert2";
import i18n from "../i18n";
import Button from "@/components/button";
import Input from "@/components/c-input";
import ItemList from "@/components/itemlist";

/* eslint-disable no-console */

export default {
  components: {
    Button,
    Input,
    ItemList,
    Loading,
  },
  data() {
    return {
      currentPage: 0,
      countPage: 0,
      perPage: 0,
      list: [],
      keySearch: "",
      clauseList: [],
      seleted: [],
      start: "1990-01-01",
      end: "1990-01-01",
      pageLast: 1,
      pageCurrent: 7,
      firstLoading: true,

      window: {
            width: 0,
            height: 0,
            table: '',
            heightLoading: 0,
        },

      showHeight: '',
      normalHeight: '',

      isLoading: true,
      isDateChanged: false,
      valueMergeProperty: false
    };
  },
  created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
  },
  destroyed() {
      window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    
    this.list = this.dataList.data;

    i18n.locale = localStorage.getItem('locale');
    if(this.isFilterable()) {

      if('checkbox' in this.filter) {
        let checkbox = this.filter.checkbox[0];
        this.valueMergeProperty = 'selected' in checkbox ? 
                  checkbox.selected : false;

          console.log(this.valueMergeProperty);
      }

      this.filter.dropdown.map((item) => {

        if('default' in item) {
          this.seleted[item.field] = item.default;
          if('method' in item) {
            item.method();
          }
        } else {
          this.seleted[item.field] = 0;
        }
      });

      const date = this.filter.date;

      //this.$moment().add(7, 'days').format('YYYY-MM-DD'),

      // this.start = date == null || date.start == null || date.start == '' ? this.$moment().clone().startOf('month').format('YYYY-MM-DD') : date.start;
      // this.end = date == null || date.end == null || date.end == '' ? this.$moment().clone().endOf('month').format('YYYY-MM-DD') : date.end;

      // this.start = date == null || date.start == null || date.start == '' ? this.$moment().clone().startOf('month').format('YYYY-MM-DD') : date.start;
      // this.start = date == null || date.start == null || date.start == '' ? this.$moment().add(-1, 'years').format('YYYY-MM-DD') : date.start;
      this.start = date == null || date.start == null || date.start == '' ? this.$moment().startOf('year').format('YYYY-MM-DD') : date.start;
      this.end = date == null || date.end == null || date.end == '' ? this.$moment().clone().endOf('month').format('YYYY-MM-DD') : date.end;

      this.isDateChanged = false;
    }

    setTimeout(() => {
        this.isLoading = false
      }, 1000);

  },

  watch: {

    dataList: function(newVal) { 
      //console.log('list changed: ', newVal, ' | was: ', oldVal);

      this.perPage = newVal.per_page;
      this.countPage = Math.ceil(newVal.total / newVal.per_page);
      this.currentPage =  newVal.current_page;

      this.list = newVal.data;

      // console.log("DATA", JSON.stringify(this.list));

      // console.log(this.currentPage, this.perPage);
    },
    start: function(newVal, oldVal) { 
      console.log(newVal, oldVal);

      if(oldVal != '1990-01-01') {
        this.isDateChanged = true;
      }
    },
    end: function(newVal, oldVal) { 
      console.log(newVal, oldVal);

      if(oldVal != '1990-01-01') {
        this.isDateChanged = true;
      }
    }

  },

  methods: {
    
    handleResize() {

        const space = 340;

        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        this.window.heightLoading = window.innerHeight - space;
        this.window.table = this.fill ? `display: flex; flex-direction: column; justify-content: center; align-items: center; height: ${this.window.height - space}px;` : '';

        this.normalHeight = this.fill ? `height: ${this.window.height - space}px;` : '';
        this.showHeight = this.fill ? `display: flex; flex-direction: column; justify-content: center; align-items: center; height: ${this.window.height - space}px;` : '';


    },

    capitalize: function(string) {
      return string.trim().charAt(0).toUpperCase() + string.trim().slice(1);
    },

    getActivePage: function (index) {

      // console.log("Meooth", index, this.currentPage);

      // return index === this.currentPage ? {active: true} : {active: false};
      return {active: (index == this.currentPage)};
    },

    hasPage: function () {
      return this.countPage > 1;
    },

    isAddable: function() {
      return this.add !== null;
    },

    isEditable: function() {
      return this.edit !== null && this.edit.link !== "";
    },

    isViewable: function() {
      return this.view !== null && this.view.link !== "";
    },

    isDeletable: function() {
      return this.deletes != null 
    },

    isMoreable: function() {
      return this.more !== null;
    },

    moreable: function() {
      let count = 0;
      if (this.more && this.more.sub) {
        count = this.more.sub.length;
      }

      return count;
    },

    isFilterable: function() {

      return Object.keys(this.filter).length !== 0; //this.filter !== null;
    },

    navigateTo: function(link, params = null) {
      let uri = {
        name: link,
      };

      if(params !== null) {
        uri[params] = params;
      }

      this.$router.push(this.$route.query.redirectFrom || uri);
    },

    submitDelete: function(id, condition = null) {

      // console.log(condition);
      let allowToRemove = true;

      if(this.deletes[1]) {
        if('operator' in this.deletes[1]) {
          allowToRemove = this.deletes[1].operator == '=' ? this.deletes[1].value == condition : this.deletes[1].value != condition;
        } else {
          allowToRemove = this.deletes[1].value == condition;
        }
      }

      if(allowToRemove) {
        this.$swal.fire({
          title: i18n.t('general.confirm.title'),
          text: i18n.t('general.confirm.message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.confirm.yes'),
          cancelButtonText: i18n.t('general.confirm.no')
        }).then(result => {
          if (result.value) {

            this.deletes[0](id);

            let index = this.list.findIndex(o => o.id === id);
            if(index >= 0) {
              this.list.splice(index, 1);
            }

          }
        });
      } else {
        this.$swal.fire({
          title: i18n.t('general.confirm.deleted'),
          text: i18n.t('general.confirm.not-allow'),
          icon: "error",
          confirmButtonText: i18n.t('general.ok')
        });
      }
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-add",
          });
    },

    submitEdit: function(id) {
      // this.$router.push(this.$route.query.redirectFrom || {
      //         name: this.edit.link,
      //         params: { id },
      //     });

      this.$router.push({
        name: this.edit.link,
        params: { id },
      });
    },

    submitView: function(id) {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-view",
              params: { id },
          });
    },

    search: function() {
      this.clauseList = [];
      this.clauseList.splice(0, this.clauseList.length);

      this.smartSearch();
      this.dropdownSearch();
      this.checkboxSearch();

      if(this.isDateChanged) {
        this.dateSearch();
      }
    },

    navigaterTo: function(param)  {
      this.navigate(param);
    },

    submitSearch: function() {

      this.search();

      this.navigaterTo("?clause=" + JSON.stringify({
        clause: this.clauseList,
      }));

      // console.log(JSON.stringify({
      //   clause: this.clauseList,
      // }));
      
    },

    dateSearch: function() {

      if('date' in this.filter) {
    
        let variable = {
          conjuction: 'and',
        };

        let field = this.filter.date.field;
        
        variable[field + "_start"] = {
            field: field,
            value: `${this.start} 00:00:00`,
            operator:">=",
            conjuction: "and"
          };

        variable[field + "_end"] = {
            field: field,
            value: `${this.end} 23:59:59`,
            operator:"<=",
            conjuction: "and"
          };

        this.clauseList.push(variable);
        
      }
    },

    smartSearch: function() {
      if(this.keySearch !== "") {
        let variable = {
          conjuction: 'and',
        };

        this.filter.search.map((item) => {
          variable[item] = {
            value:`${this.keySearch}`,
            operator:"like",
            conjuction: "or"
          };
        });

        

        this.clauseList.push(variable);

        console.log(JSON.stringify(this.clauseList));
      }
    },

    dropdownSearch: function() {

      if('dropdown' in this.filter) {

        let variable = {
          conjuction: 'and',
        };

        let isSearch = false;
        this.filter.dropdown.map((item) => {
          if(this.seleted[item.field] != 0) {

            let conditions = [];
            if('conditions' in item) {
              item.conditions.map((cond) => {
                conditions.push(cond.value);
              });
            }

            isSearch = true;
            if(conditions.includes(this.seleted[item.field])) {
              let fields = item.conditions.filter((v) => {
                return v.value === this.seleted[item.field]
              })[0].fields;

              fields.map((field) => {
                variable[field.name] = {
                  value: field.value,
                  operator: field.operator
                };           
              });

            } else {
              variable[item.field] = {
                value: this.seleted[item.field]
              };
            }
          } 
        });

        
        isSearch && this.clauseList.push(variable);
      }

      // console.log(JSON.stringify(this.clauseList));
    },

    checkboxSearch: function() {
      if('checkbox' in this.filter) {

        if(!this.valueMergeProperty) return;

        this.filter.checkbox.map((item) => {

          let variable = {
            conjuction: 'and',
          };

          variable[item.field] = {
            value: item.value,
            operator: item.operator,
          }
          
          this.clauseList.push(variable);
        });
      }
    },

    handleNavigate: function(param) {
      this.search();

      param = param + "&clause=" + JSON.stringify({
        clause: this.clauseList,
      });

      // console.log(JSON.stringify(param));

      this.navigaterTo(param);
    },

    renderFormatColumn: function(name, value, id, color = 'info') {

      let data = value;
      if(this.formats == null) { return value; }

      this.formats.map((item) => {    

        if((item.name == name)) {
          if('type' in item) {
            if(item.type == 'date') {
              data = this.$moment(value).format('DD/MM/YYYY');
            } else if(item.type == 'currency') {
              let sign = 'sign' in item ? item.sign : '';
              let decimal = 'decimal' in item ? item.decimal : '.00';
              data = this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
            } else if(item.type == 'fast-view') {
              data = `<a href="javascript:void(0);" @click="console.log('Hi')" ref="fastview-${id}" class="font-size-13 m-0">${value}</a>`
            }
          } else  {
            // let color = 'info';
            if(('color' in item) || !item.color) {
              color = 'info';
            }

            data = (`<a class="badge bg-${color} font-size-12 m-1" style="padding: 5px">${value}</a>`);

            // data = (`<a class="badge badge-soft-${color} font-size-13 m-0" style="padding: 5px">${value}</a>`);
          } 
        }
      });

      return data;
    },

    generateMoreObject(items, lists) {
      let type = 'query' in items ? 'query' : 'params';
      let route = 'query' in items ? {
        path: items.link
      } : {
        name: items.link
      };

      if('column' in items && items.column != null) {
        let paramId = 'param' in items  ? items.param : 'query' in items  ? items.query : 'id';
        route[type] = JSON.parse(`{"${paramId}": ${lists[items.column]}}`);
      }

      // console.log(JSON.stringify(route));

      return route;
    },

  },
  props: {
    module: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
    },
    formats: {
      type: Array,
    },
    dataList: {
      type: Object,
    },
    updating: {
      type: Boolean,
      default: true,
    },
    add: {
      type: Object,
      default: null,
    },
    edit: {
      type: Object,
      default: null,
    },
    view: {
      type: Object,
      default: null,
    },
    deletes: [],
    more: {
      type: Object,
      default: null,
    },
    fastView: {
      type: Function,
      default: null,
    },
    fastViewColumn: {
      type: Array,
    },
    filter: {
      type: Object,
      default: null,
    },
    navigate: {
      type: Function,
      default: null,
    },
    fill: {
      default: true
    },
    showLoading: {
      default: true
    },
    showNo: {
      default: true
    },
    filterValue: {
      type: Object,
      default: null,
    },
    operation: {
      type: String,
      default: '=',
    },
    property: {
      default: false
    }
  },
};
</script>
<template>
    
   <div class="row" style="width: '100%', overflow: auto; position: relative;" >
      <Loading :loaded="updating" :height="window.heightLoading" />
      <div v-show="updating" class="col-lg-12">
        <div class="row"> 
          <div v-show="isFilterable()" class="row">
              <div class="col-lg-12" style="margin-bottom: 5px;">
                <b-form @submit.prevent="submitSearch()" inline class="row gy-2 gx-3">
                  <div v-show="filter.search" class="col-sm-2">
                    <b-form-group
                      class="mb-3"
                      :label="$t('general.search')"
                      label-for="key"
                    >
                      <b-form-input
                        id="key"
                        type="text"
                        v-model="keySearch"
                        :placeholder="$t('general.search')"
                        @keyup.enter="submitSearch()"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div v-for="(dp, index) in filter.dropdown" :key="index" :class="'width' in dp ? `col-sm-${dp.width}` : 'col-sm-1'">
                    <b-form-group
                      class="mb-1"
                      :label="$t(dp.title)"
                      label-for="key"
                    >
                      <b-form-select
                        class="form-select"
                        @change="dp.method"
                        v-model="seleted[dp.field]"
                        :id="dp.field"
                      >
                        <option v-for="(selectOption, indexOpt) in dp.data" 
                          :key="indexOpt"
                          :value="selectOption.id"
                        >
                          {{ ('show' in dp) ? selectOption[dp.show] : selectOption.name }}
                        </option>
                        <template v-slot:first>
                          <option value="0">{{`${$t('general.all')}`}}</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div v-if="'date' in filter" class="col-sm-3 row" style="padding-top: 7px;">

                    <div class="col-sm-6">
                      <Input 
                          :type="'date'"
                          :id="'start'"
                          v-model="start"
                          :label="'general.start-date'"  />
                    </div>
                    <div class="col-md-6">
                      <Input v-if="'date' in filter"
                          :type="'date'"
                          :id="'end'"
                          v-model="end"
                          :label="'general.end-date'"  />
                    </div>

                  </div>
                  <div v-show="'checkbox' in filter" class="col-md-2">
                    <div v-for="(cb, index) in filter.checkbox" :key="index" >
                      <div class="" style="margin-top: 33px;">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="type_id"
                          v-model="valueMergeProperty"
                        />
                        <label class="form-check-label" for="type_id" style="margin-left: 5px;"
                          >{{$t('property.merge.text')}}</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-2" style="margin-top: 35px;">
                    <Button v-bind:icon="'bx bx-search-alt-2 bx-tada'" 
                      v-bind:buttonType="'button'"
                      v-bind:title="$t('general.search')"
                      @click="submitSearch()"  />
                  </div>
                </b-form>
              </div>
            </div>
            <div class="table-responsive" :style="normalHeight">

              <table class="table align-middle table-nowrap table-hover" >
                  <thead class="table-light">
                    <tr>
                      <th v-show="showNo" class="align-center">
                        {{$t('general.number')}}
                      </th>
                      <th v-for="field in fields" :key="field" scope="col">
                        <div v-if="(field.split(':'))[1] == null">
                          {{capitalize(field)}}
                        </div>
                        <div v-else>
                          {{capitalize((field.split(':'))[1])}}
                        </div>
                      </th>
                      <th class="align-center">
                        {{isDeletable() || isEditable() ? $t('general.action') : ''}}
                      </th>
                      <!-- <th class="align-center" v-show="isDeletable() || isEditable()">
                        {{$t('general.action')}}
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr v-for="(list, index) in this.list" :key="list.id">
                      <td v-show="showNo">
                        <div class="avatar-xs">
                          <span class="avatar-title rounded-circle">{{(index+(perPage*(currentPage-1)))+1}}</span>
                        </div>
                      </td>

                      <td v-for="(field, index) in fields" :key="field">
                        <ItemList 
                          :id="index"
                          :filters="$options.filters"
                          :item="{id: list.id, name: (field.split(':'))[0], value: list[(field.split(':'))[0]], color: list.color, object: list}"
                          :formats="formats"
                          @view="(event) => $emit('view', event)" />
                      </td>

                      <!-- <td v-for="field in fields" :key="field">
                        <div v-html="renderFormatColumn((field.split(':'))[0], list[(field.split(':'))[0]], list.id, list.color)" /> 
                      </td> -->

                      <td style="width: 100px;">
                        <ul class="list-inline font-size-20 contact-links mb-0 pagination-rounded">
                          <li v-show="isMoreable()" class="list-inline-item px-2">
                            <div v-if="isMoreable()">
                              <b-dropdown size="sm"  variant="outline" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" menu-class="dropdown-toggle dropdown-menu-end" class="font-size-20  page-link bg-light pagination-rounded">
                                <template class="page-link bg-light" v-slot:button-content>
                                    <i class="bx bx bx-dots-horizontal-rounded" style=" margin-top: 5px"></i>
                                </template>
                                <div v-for="(item, index) in more.sub" :key="index">  
                                  <div v-if="'action' in item">
                                    <div v-if="'show' in item">
                                      <div v-if="list[item.show.column] == item.show.value">
                                        <b-dropdown-item @click="$emit('more', item.action, list.id)">
                                          <i v-if="item.icon" :class="`${item.icon} font-size-16 align-middle mr-1`"></i>
                                          {{$t(item.name)}}
                                        </b-dropdown-item>
                                      </div>
                                    </div>
                                    <div v-else>
                                      <b-dropdown-item @click="$emit('more', item.action, list.id)">
                                        <i v-if="item.icon" :class="`${item.icon} font-size-16 align-middle mr-1`"></i>
                                        {{$t(item.name)}}
                                      </b-dropdown-item>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div v-if="'show' in item">
                                      <div v-if="'operation' in item.show">
                                        <div v-if="item.show.operation == '>=' && list[item.show.column] >= item.show.value">
                                          <b-dropdown-item :to="generateMoreObject(item, list)" :target="'target' in item ? item.target : ''">
                                            <i v-if="item.icon" :class="`${item.icon} font-size-16 align-middle mr-1`"></i>
                                            {{$t(item.name)}}
                                          </b-dropdown-item>
                                        </div>
                                        <div v-else-if="item.show.operation == '<=' && list[item.show.column] <= item.show.value">
                                          <b-dropdown-item :to="generateMoreObject(item, list)" :target="'target' in item ? item.target : ''">
                                            <i v-if="item.icon" :class="`${item.icon} font-size-16 align-middle mr-1`"></i>
                                            {{$t(item.name)}}
                                          </b-dropdown-item>
                                        </div>
                                        <div v-else>
                                          <b-dropdown-item :to="generateMoreObject(item, list)" :target="'target' in item ? item.target : ''">
                                            <i v-if="item.icon" :class="`${item.icon} font-size-16 align-middle mr-1`"></i>
                                            {{$t(item.name)}}
                                          </b-dropdown-item>
                                        </div>
                                      </div>
                                      <div v-else>
                                        <div v-if="list[item.show.column] == item.show.value">
                                          <b-dropdown-item :to="generateMoreObject(item, list)" :target="'target' in item ? item.target : ''">
                                            <i v-if="item.icon" :class="`${item.icon} font-size-16 align-middle mr-1`"></i>
                                            {{$t(item.name)}}
                                          </b-dropdown-item>
                                        </div>
                                      </div>
                                      
                                    </div>
                                    <div v-else>
                                      <b-dropdown-item :to="generateMoreObject(item, list)" :target="'target' in item ? item.target : ''">
                                        <i v-if="item.icon" :class="`${item.icon} font-size-16 align-middle mr-1`"></i>
                                        {{$t(item.name)}}
                                      </b-dropdown-item>
                                    </div>
                                  </div>
                                </div>
                              </b-dropdown>
                            </div>
                          </li>

                          <li v-show="isViewable()" class="list-inline-item px-2">
                            <div v-if="isViewable()">
                              <router-link class="page-link bg-success" 
                              :to="{ name: view.link, params: { id: list.id }}">
                                <i class="bx bx bx-show-alt bx-tada" style="color: white; margin-top: 5px"></i>
                              </router-link>
                            </div>
                          </li>
                          <li v-show="isEditable()" class="list-inline-item px-2">
                            <div v-if="isEditable()">
                              <router-link class="page-link bg-info" 
                                :to="{ name: edit.link, params: { id: list.id }}">
                                <i class="bx bx-edit" style="color: white; margin-top: 5px"></i>
                              </router-link>
                            </div>
                          </li>
                          <li v-show="isDeletable()" class="list-inline-item px-2">
                            <a href="#" @click="submitDelete(list.id, deletes[1] == null ? null : list[deletes[1].field])" v-b-tooltip.hover :title="$t('general.remove')" class="page-link bg-danger">
                              <i class="bx bx-trash" style="color: white; margin-top: 5px"></i>
                            </a>
                          </li>
                            
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
                    <!-- <div v-show="!isLoading" :style="showHeight">
                      <div  class="preloader-component">
                        <div class="status">
                          <div class="spinner-chase">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                    </div> -->
            </div>
            <div v-show="hasPage()" class="row">
        
              <div class="col-lg-12">
                <ul class="pagination pagination-rounded justify-content-center">
                  <!-- <li class="page-item disabled">
                    <a href="#" class="page-link">
                      <i class="mdi mdi-chevron-left"></i>
                    </a>
                  </li> -->
                  <div v-if="countPage <= 10" class="pagination pagination-rounded justify-content-center">
                    <li v-for="index in countPage" :key="index" class="page-item" :class="{active: (index == currentPage)}">
                      <a href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                    </li>            
                  </div> 
                  <div v-else>
                    <div v-if="currentPage<=pageCurrent-2" class="pagination pagination-rounded justify-content-center">
                      <li v-for="index in pageCurrent" :key="index" class="page-item" :class="{active: (index == currentPage)}">
                        <a href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                      </li>   
                      <span style="margin-left: 10px; margin-right: 10px">  . . .  </span>
                      <li v-for="index in countPage" :key="index" class="page-item">
                        <a v-if="index >= countPage - pageLast"  href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                      </li> 
                    </div>
                    <div v-if="currentPage > pageCurrent-2 && currentPage<= countPage-(pageCurrent-2)" class="pagination pagination-rounded justify-content-center">
                      <li v-for="index in 2" :key="index" class="page-item" :class="{active: (index == currentPage)}">
                        <a href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                      </li> 
                      <span style="margin-left: 10px; margin-right: 10px">  . . .  </span>
                      <li v-for="index in (+currentPage)+2" :key="index" class="page-item" :class="{active: (index == currentPage)}">
                        <a v-if="index >= (+currentPage)-2" href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                      </li>   
                      <span style="margin-left: 10px; margin-right: 10px">  . . .  </span>
                      <li v-for="index in countPage" :key="index" class="page-item">
                        <a v-if="index >= countPage - pageLast"  href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                      </li> 
                    </div>
                    <div v-if="currentPage > countPage-(pageCurrent-2)" class="pagination pagination-rounded justify-content-center">
                      <li v-for="index in 2" :key="index" class="page-item" :class="{active: (index == currentPage)}">
                        <a href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                      </li>   
                      <span style="margin-left: 10px; margin-right: 10px">  . . .  </span>
                      <li v-for="index in countPage" :key="index" class="page-item" :class="{active: (index == currentPage)}">
                        <a v-if="index > countPage - pageCurrent"  href="#" @click="handleNavigate('?page=' + index)" class="page-link">{{(index)}}</a>
                      </li> 
                    </div>
                  </div>          
                  <!-- <li class="page-item">
                    <a href="#" class="page-link">
                      <i class="mdi mdi-chevron-right"></i>
                    </a>
                  </li> -->
                </ul>
              </div>

            </div>


        </div>
      </div>

  </div>
  
</template>